<template>
  <div>
    <div class="content-wrapper">
      <div class="content-wrapper__dateTime" v-if="responseDateTime">
        <span>
          Bes Toplam Kayıt Tarihi:
          <span :class="dateStyle">{{ responseDateTime }}</span>
        </span>
      </div>
      <div class="content-wrapper__item text-center">
        <h3 class="content-wrapper__item__title text-center">
          Mevcut Limit Değeri: {{ formatPriceNoDecimal(overallLimit) }} TL
        </h3>
        <base-button
          class="content-wrapper__item__detail__button"
          @click="showModal('department-choose')"
          :class="{ 'disabled pointer-none': isCustomerListDownloaded }"
          >Şube Seç</base-button
        >
        <base-button
          class="content-wrapper__item__detail__button"
          :class="{ 'disabled pointer-none': isCustomerListDownloaded }"
          @click="getMonthlyExcel"
          >Limit Altındaki Müşteri Listesi indir</base-button
        >
        <info-area
          :infoText="'İndirilen müşteri listesi 1 saat boyunca geçerlidir. 1 saat ardından yeniden müşteri listesi indirmeniz gerekmektedir.'"
        ></info-area>
        <info-area
          :infoText="'İndirme işlemi başlatıldığında M3C servisinden güncel limit değerleri alınarak tüm müşterilerin limit değerleri güncellenecektir.'"
        ></info-area>
      </div>
      <div class="content-wrapper__item seperator">
        <div class="content-wrapper__item__detail seperated">
          <h3 class="content-wrapper__item__title">Uyarı Kapama İşlemleri</h3>
          <base-button
            class="content-wrapper__item__detail__button"
            @click="showModal('mail-send')"
            :class="{ 'disabled pointer-none': isCustomerListDownloaded }"
            >Uyarı kapama maili gönder</base-button
          >
        </div>

        <div class="content-wrapper__item__detail seperate">
          <h3 class="content-wrapper__item__title">
            Terminal Kapama İşlemleri
          </h3>

          <base-button
            class="content-wrapper__item__detail__button"
            :class="{ 'disabled pointer-none': isCustomerListDownloaded }"
            @click="showModal('terminal-send')"
            >Terminal Kapama İşlemleri</base-button
          >
        </div>
      </div>
      <div class="content-wrapper__item">
        <h3 class="content-wrapper__item__title my-20">
          Son Yapılan İşlemler:
        </h3>
        <h4 class="content-wrapper__item__title font-small">
          <span v-if="timerRunning">
            Liste
            <span>{{ countDown }}</span> saniye içerisinde yenilenecektir.
          </span>
          <span v-else>Yenilenme durduruldu.</span>
        </h4>

        <base-button
          class="content-wrapper__item__detail__button cancel-button"
          :class="{ warning: timerRunning }"
          @click="toggleCountdown"
          v-if="!logsLoader"
        >
          <div v-if="timerRunning">Yenilenmeyi durdur.</div>
          <div v-else>Yenilemeyi devam ettir.</div>
        </base-button>

        <div class="content-wrapper__item__table">
          <div v-if="logsLoader">
            <base-icon class="loader-icon" name="loader"></base-icon>
          </div>
          <table class="table" aria-describedby="logs" v-else>
            <thead>
              <th v-for="item in logsHeader" :key="item.id">
                <span v-if="item == 'id'"></span>
                <span v-if="item == 'type'">Tip</span>
                <span v-if="item == 'transactionUser'">İşlem Kullanıcısı</span>
                <span v-if="item == 'startDate'">Başlangıç Tarihi</span>
                <span v-if="item == 'endDate'">Bitiş Tarihi</span>
                <span v-if="item == 'time'">Süre</span>
                <span v-if="item == 'effectedCustomerCount'"
                  >Etkilenen Müşteri Sayısı</span
                >
                <span v-if="item == 'effectedPurchaseCount'"
                  >Etkilenen Paket Sayısı</span
                >
                <span v-if="item == 'message'">Mesaj</span>
                <span v-if="item == 'filePath'">Liste</span>
              </th>
            </thead>
            <tbody>
              <tr v-for="item in logs" :key="item.id">
                <td></td>
                <td v-if="item.type">{{ item.type }}</td>
                <td v-else>-</td>
                <td v-if="item.transactionUser">{{ item.transactionUser }}</td>
                <td v-else>-</td>
                <td v-if="item.startDate">
                  {{ getTime(item.startDate, "DD/MM/YYYY HH:mm") }}
                </td>
                <td v-else>-</td>
                <td v-if="item.endDate">
                  {{ getTime(item.endDate, "DD/MM/YYYY HH:mm") }}
                </td>
                <td v-else>-</td>
                <td v-if="item.time">{{ item.time }}</td>
                <td v-else>-</td>
                <td v-if="item.effectedCustomerCount">
                  {{ item.effectedCustomerCount }}
                </td>
                <td v-else>-</td>
                <td v-if="item.effectedPurchaseCount">
                  {{ item.effectedPurchaseCount }}
                </td>
                <td v-else>-</td>
                <td v-if="item.message">{{ item.message }}</td>
                <td v-else>-</td>
                <td v-if="item.filePath">
                  <div
                    @click="downloadFile(item.filePath)"
                    class="download-button"
                  >
                    İndir
                  </div>
                </td>
                <td v-else>-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <modal
        height="auto"
        class="month-closer-modal"
        :minWidth="900"
        :adaptive="true"
        :minHeight="400"
        :name="modalName"
        :class="{ autoHeight: mailTemplate.toggleClassForHeight }"
      >
        <div class="modal-heading">
          <div class="modal-title" v-if="modalName == 'mail-send'">
            <h5>Uyarı maillerinin gönderimini onaylıyor musun?</h5>
          </div>
          <div class="modal-title" v-if="modalName == 'terminal-send'">
            <h5>Kapatma maillerinin gönderimini onaylıyor musun?</h5>
          </div>
          <div class="modal-title" v-if="modalName == 'department-choose'">
            <h5>Şube Seçiniz</h5>
          </div>
          <a @click="closeModal(modalName)">
            <base-icon class="close" name="close-circle" />
          </a>
        </div>
        <div class="modal-body">
          <div class="modal-body__top">
            <div
              class="modal-body__info"
              v-if="modalName != 'department-choose'"
            >
              Uyarı: Onay verdikten sonra işlemde duraklatma, durdurma v.b
              işlemler yapılamaz.
            </div>
            <div class="modal-body__detail">
              <div class="accordion" v-if="modalName != 'department-choose'">
                <div class="accordion__button" @click="toggleTemplateView">
                  Mail görünümü örneği
                  <base-icon
                    name="order-arrow-down"
                    v-if="!mailTemplate.isActive"
                    class="toggle-dropdown"
                  />
                  <base-icon
                    name="order-arrow-up"
                    v-else
                    class="toggle-dropdown"
                  />
                  <base-icon
                    class="loader-icon"
                    name="loader"
                    v-if="mailTemplate.isLoading"
                  ></base-icon>
                </div>
                <div class="accordion__content" v-if="mailTemplate.isActive">
                  <div
                    class="accordion__content__wrapper"
                    v-for="item in mailTemplate.templateData"
                    :key="item.body"
                  >
                    <div
                      v-if="item.id === 4 && modalName == 'mail-send'"
                      class="accordion__content__wrapper__title"
                    >
                      <div
                        v-html="item.body"
                        class="accordion__content__wrapper__items"
                      ></div>
                    </div>
                    <div
                      v-if="item.id === 5 && modalName == 'terminal-send'"
                      class="accordion__content__wrapper__title"
                    >
                      <div
                        v-html="item.body"
                        class="accordion__content__wrapper__items"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="multi_select"
                v-if="modalName === 'department-choose'"
              >
                <div
                  class="select_button"
                  @click="selectAll"
                  v-if="!department.selectBoxControls.isAllSelected"
                >
                  Hepsini Seç
                </div>
                <div
                  class="select_button"
                  @click="selectAll"
                  v-if="department.selectBoxControls.isAllSelected"
                >
                  Hepsini kaldır
                </div>

                <vue-select
                  multiple="multiple"
                  :options="department.selectableDepartmentList"
                  class="month-closing-selectbox"
                  v-model="department.selectedDepartments"
                ></vue-select>
                <p>
                  Seçilen şube sayısı:
                  {{ department.selectedDepartments.length }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-bottom" :style="{ display: isModalButtonsActive }">
          <base-button
            @click="sendMailOnClick()"
            v-if="modalName == 'mail-send'"
            >Evet</base-button
          >
          <base-button
            @click="closeTerminal()"
            v-if="modalName == 'terminal-send'"
            >Evet</base-button
          >
          <base-button
            @click="sendDepartmentChooses()"
            v-if="modalName == 'department-choose'"
            >Evet</base-button
          >
          <base-button class="warning" @click="closeModal(modalName)"
            >Hayır</base-button
          >
          <base-icon
            class="loader-icon"
            name="loader"
            v-if="isButtonClicked"
          ></base-icon>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import { BaseButton, BaseIcon, InfoArea } from "@/components";
import { mapActions } from "vuex";
import mixins from "../mixins";

export default {
  name: "MonthClosing",
  components: { BaseButton, BaseIcon, InfoArea, VueSelect },
  mixins: [mixins],
  data() {
    return {
      isCustomerListDownloaded: false,
      isButtonClicked: false,
      isMailSended: false,
      isModalButtonsActive: true,
      logsHeader: [],
      logs: [],
      logsLoader: false,
      modalName: "",
      overallLimit: "",
      department: {
        selectableDepartmentList: [],
        selectedDepartments: [],
        selectBoxControls: {
          isAllSelected: false,
          isAllSelectedTrue: false,
        },
      },
      mailTemplate: {
        templateData: "",
        isLoading: false,
        isActive: false,
        toggleClassForHeight: false,
      },
      countDown: 10,
      timerRunning: true,
      timerStatus: "Yenileniyor",
      responseDateTime: null,
      todayDateTime: this.$moment(new Date()).format("DD.MM.YYYY"),
    };
  },
  computed: {
    dateStyle() {
      const today = new Date();

      const backendDate = this.parseDate(this.responseDateTime);
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      if (!backendDate) {
        return "red";
      }

      const isSameDay =
        backendDate.getDate() === yesterday.getDate() &&
        backendDate.getMonth() === yesterday.getMonth() &&
        backendDate.getFullYear() === yesterday.getFullYear();

      return isSameDay ? "black" : "red";
    },
  },
  methods: {
    ...mapActions([
      "checkMonthClosingProcessStatus",
      "monthlyExcelList",
      "sendMonthlyMail",
      "getMonthOverall",
      "getMonthClosedLogList",
      "getMonthClosingMailTemplates",
      "monthlyGetOverallLimit",
      "monthClosingGetDepartmentList",
      "monthClosingPostSelectedDepartment",
      "monthClosingDateTime",
    ]),
    parseDate(dateString) {
      if (!dateString) return null;
      const [day, month, year] = dateString.split(".");
      return new Date(year, month - 1, day);
    },
    closeTerminal() {
      this.getMonthOverall().then((response) => {
        if (response.status == 200) {
          this.closeModal("terminal-send");
          this.$toast.info("İşleminiz başlamıştır.");
        }
      });
    },
    getStatus() {
      this.checkMonthClosingProcessStatus().then((response) => {
        if (response.status === 200) {
          this.isCustomerListDownloaded = response.data.key;
          if (this.isCustomerListDownloaded === true) {
            this.$toast.info(
              "İşleminiz devam etmektedir. Sonucu aşağıdaki liste güncellenince takip edebilirsiniz."
            );
            this.timerRunning = true;
          }
        }
      });
    },
    getMonthlyExcel() {
      this.monthlyExcelList().then(() => {
        this.isCustomerListDownloaded = true;

        this.getStatus();
        this.$toast.success(
          "İşleminiz başlamıştır sonucunu aşağıdaki listeden takip edebilirsiniz."
        );
      });
    },
    getClosingDateTime() {
      this.monthClosingDateTime().then((response) => {
        this.responseDateTime = response;
      });
    },
    downloadFile(filePath) {
      const createElem = document.createElement("a");
      const setUrls = process.env.VUE_APP_API_URL + "/" + filePath;
      createElem.setAttribute("href", setUrls);
      createElem.click();
    },
    getMonthClosedLogs() {
      this.getMonthClosedLogList().then((response) => {
        this.logs = response.data;
        if (this.logs.length) {
          this.logsHeader = Object.keys(this.logs[0]);
        }
      });
    },
    getOverallLimitOnLoad() {
      this.monthlyGetOverallLimit().then((response) => {
        if (response.status === 200) {
          this.overallLimit = response.data.overallLimit;
        }
      });
    },
    getMonthClosingMailTemplate() {
      this.getMonthClosingMailTemplates().then((response) => {
        if (response.data.error) {
          this.$toast.error(response.data.message);
          this.mailTemplate.isLoading = false;
        } else {
          this.mailTemplate.templateData = response.data;
          this.mailTemplate.isActive = !this.mailTemplate.isActive;
          this.mailTemplate.isLoading = false;
        }
      });
    },
    getMonthClosingGetDepartmentList() {
      this.monthClosingGetDepartmentList().then((response) => {
        if (response.status == 200) {
          this.department.selectableDepartmentList = [];
          response.data.forEach((element) => {
            this.department.selectableDepartmentList.push({
              label: element.name,
              code: element.id,
              isMonthClosingBranch: element.isMonthClosingBranch,
              no: element.no,
            });
          });
          this.department.selectedDepartments =
            this.department.selectableDepartmentList.filter(
              (x) => x.isMonthClosingBranch === true
            );
          if (
            this.department.selectedDepartments.length == response.data.length
          ) {
            this.department.selectBoxControls.isAllSelected = true;
            this.department.selectBoxControls.isAllSelectedTrue = true;
          }
        }
      });
    },
    sendDepartmentChooses() {
      let selectedDepartmentNo = this.department.selectedDepartments.map(
        (x) => x.no
      );
      if (selectedDepartmentNo.length == 0) {
        this.$toast.error("Şube seçimi boş güncellenemez.");
      } else {
        this.monthClosingPostSelectedDepartment({
          SelectedBranchNoList: selectedDepartmentNo,
        }).then(() => {
          this.$toast.success("Şube seçimleri başarılı.");
          this.$modal.hide("department-choose");
          this.getMonthClosingGetDepartmentList();
        });
      }
    },
    getTime(dateTime, formatType) {
      let stringDateTime = String(dateTime);
      let generateMomentDate = this.$moment(new Date(stringDateTime)).format(
        formatType
      );
      return generateMomentDate;
    },
    sendMailOnClick() {
      if (!this.isCustomerListDownloaded) {
        this.isButtonClicked = true;
        this.sendMonthlyMail().then((response) => {
          if (response.status === 200 || response) {
            this.isCustomerListDownloaded = false;
            this.$modal.hide("mail-send");
            this.$toast.success(
              "İşleminiz başlamıştır sonucunu aşağıdaki listeden takip edebilirsiniz."
            );
            this.isMailSended = true;
            this.isButtonClicked = false;
          }
        });
      } else {
        this.$toast.error(
          "Excel listesi oluşturuluyor lütfen bir süre daha bekleyiniz."
        );
      }
    },
    selectAll() {
      if (!this.department.selectBoxControls.isAllSelected) {
        this.department.selectedDepartments = [
          ...this.department.selectableDepartmentList,
        ];
      } else {
        this.department.selectedDepartments =
          this.department.selectedDepartments.filter((item) => item.code == 1);
      }
      this.department.selectBoxControls.isAllSelected =
        !this.department.selectBoxControls.isAllSelected;
    },
    showModal(param) {
      this.modalName = param;
      this.$nextTick(() => {
        this.$modal.show(this.modalName);
      });
    },
    closeModal(param) {
      this.$nextTick(() => {
        this.$modal.hide(param);
      });
      this.modalName = "";
    },
    toggleTemplateView() {
      if (!this.mailTemplate.isActive) {
        this.mailTemplate.isLoading = true;
        this.getMonthClosingMailTemplate();
        this.mailTemplate.toggleClassForHeight = false;
      } else {
        this.mailTemplate.isActive = !this.mailTemplate.isActive;
        this.mailTemplate.toggleClassForHeight = true;
      }
    },
    toggleCountdown() {
      this.timerRunning = !this.timerRunning;
      if (!this.timerRunning) {
        this.timerStatus = "Duraklatıldı";
      } else {
        this.timerStatus = "Yenileniyor.";
        this.countDown = 10;
      }
    },
  },
  mounted() {
    this.getOverallLimitOnLoad();
    this.getMonthClosedLogs();
    this.getMonthClosingGetDepartmentList();
    this.getClosingDateTime();
  },
  watch: {
    countDown: {
      handler(value) {
        if (value >= -1) {
          if (this.timerRunning) {
            setTimeout(() => {
              this.countDown--;
              if (this.countDown === 0) {
                this.logsLoader = true;
                this.getStatus();
                this.getMonthClosedLogs();
              } else if (this.countDown === -1) {
                this.logsLoader = false;
                this.countDown = 10;
              }
            }, 1000);
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-wrapper {
  display: flex;
  justify-content: center;
  margin: 10px auto;
  &__item {
    padding: 5px;
    cursor: pointer;
    max-width: 350px;
    &:first-child {
      margin-right: 10px;
    }
    &.text-center {
      text-align: center;
    }
  }
}
.content-wrapper {
  padding: 0px 20px;

  &__dateTime {
    text-align: right;
    font-weight: bold;
    margin-bottom: 40px;
    @media (max-width: 992px) {
      text-align: center;
      margin: 20px auto;
    }
    .black {
      color: #000;
    }
    .red {
      color: red;
    }
  }
  &__item {
    width: 100%;
    &.seperator {
      display: flex;
      margin: 40px auto;
      justify-content: space-around;
      @media (max-width: 992px) {
        display: block;
      }
      &.seperated {
        max-width: 50%;
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        flex-direction: column;
      }
    }
    &__title {
      margin-bottom: 20px;
      display: block;
      text-align: left;
      &.my-20 {
        margin: 20px auto;
      }
      &.font-small {
        font-size: 12px;
        font-weight: normal;
        font-style: italic;
        margin-bottom: 5px;
      }
      &.text-center {
        text-align: center;
      }
    }
    &__detail {
      @media (min-width: 992px) {
        max-width: 50%;
      }
      &__button {
        max-width: 300px;
        margin-right: 10px;
        &.cancel-button {
          max-width: 210px;
        }
        &.warning {
          background-color: var(--color-warning);
        }
        @media (max-width: 992px) {
          max-width: 100%;
          margin-bottom: 10px;
        }

        &:last-child {
          margin-right: 0px;
        }
      }
    }
    &__table {
      position: relative;
      @media (max-width: 992px) {
        overflow-x: scroll;
      }
      .loader-icon {
        right: auto;
      }
      .table {
        border-collapse: collapse;
        text-indent: 0;
        border-color: inherit;
        min-width: 100%;
        border-radius: var(--radius-second) !important;
        overflow-x: hidden;
        border: solid 1px #e9e9eb;
        background-color: #fff;
        margin: 20px 0;
        overflow-y: visible !important;
        .download-button {
          background-color: var(--color-primary-default);
          color: var(--grayscale-0);
          padding: 5px;
          border: 1px solid var(--color-primary-default);
          border-radius: 5px;

          transition: all 0.2s ease-in;
          cursor: pointer;
          &:hover {
            background-color: var(--grayscale-0);
            color: var(--color-primary-default);
          }
        }
        @media (max-width: 1024px) {
          overflow-x: scroll;
        }
        th,
        td {
          font-size: 14px;
          padding: 18px 12px;
          vertical-align: middle;
          border-top: 1px solid #e8e8e8;
          text-align: center;
        }
        tbody {
          tr td:first-child {
            width: 20px;
          }
        }
      }
    }
  }
}
.month-closer-modal.autoHeight > ::v-deep .vm--modal {
  height: auto !important;
}
.month-closer-modal {
  z-index: 9999;

  ::v-deep .vm--modal {
    overflow-y: scroll;
    @media (max-width: 1024px) {
      width: 90% !important;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }
  .multi_select {
    display: block;
    margin: 0px auto 20px auto;
    max-width: 600px;
    position: relative;

    ::v-deep .month-closing-selectbox {
      width: 100%;
      .vs__dropdown-toggle {
        min-height: 50px;
        border: 1px solid #41807a;
        height: auto;
      }
      .vs__selected {
        &:first-child {
          margin-left: 0px;
        }
        margin: 3px;
        padding: 10px;
        margin-bottom: 0px;
      }
      ul[role="listbox"] {
        height: 110px;
        overflow-y: scroll;
      }
    }
    .select_button {
      border-radius: 7px;
      padding: 10px;
      max-width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 5px;
      cursor: pointer;
      background-color: #41807a;
      color: #fff;
    }
    p {
      margin-top: 10px;
      font-size: 12px;
      color: #41807a;
    }
  }
  .modal-heading {
    height: 40px;
    border-bottom: 1px solid var(--grayscale-30);
    display: flex;
    align-items: center;
    padding: 15px 30px;
    justify-content: space-between;
    .close {
      margin: 5px;
      cursor: pointer;
    }
  }
  .modal-bottom {
    margin-top: 1em;
    border-top: 1px solid var(--grayscale-30);
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
    .base-button {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      width: 180px;
      font-size: 15px;
      &.warning {
        background-color: var(--color-warning);
      }
    }
  }
  .modal-body {
    padding: 15px 30px;
    &__top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &__image {
      .image {
        margin-right: 30px;
        width: 96px;
        height: 140px;
        -o-object-fit: contain;
        object-fit: contain;
      }
    }
    &__detail {
      width: 100%;
      margin-top: 20px;
      .base-form-input {
        ::v-deep input {
          height: 40px;
        }
      }
      .accordion {
        position: relative;
        &__button {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #000;
          padding: 10px 0px;
          padding-bottom: 0px;
          margin-bottom: 20px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
        }
        &__content {
          &__wrapper {
            &__title {
              font-size: 14px;
              font-weight: bold;
              text-decoration: underline;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
}
.infoArea {
  position: relative;
  text-align: left;
  padding: 0px;
  margin-top: 1em;
  justify-content: center;
  background-color: var(--grayscale-10);
  color: var(--color-body-text);
}
.pointer-none {
  pointer-events: none;
}
</style>
